import { atom } from 'recoil';

// 열린 레이드 ID
export const openRaidIdState = atom<string | null>({
  key: 'openRaidIdState',
  default: null,
});

// 레이드 알림 표시 여부
export const raidNotificationState = atom<{
  isOpen: boolean;
  raidId: string | null;
  raidTitle: string;
  message: string;
}>({
  key: 'raidNotificationState',
  default: {
    isOpen: false,
    raidId: null,
    raidTitle: '',
    message: '',
  },
});

